import { ReactElement, ReactNode } from 'react';
import { useUnreadNotifications } from '../../api/hooks/event-notifications.hooks';
import { useIntercomUnreadNotificationCount } from '../../config/intercom';

interface UnreadBadgeProps {
  children: ReactNode;
  borderColor?: string;
}

const UnreadBadge = (props: UnreadBadgeProps): ReactElement => {
  const unread = useUnreadNotifications() ?? 0;
  const intercomNotificationCount = useIntercomUnreadNotificationCount() ?? 0;

  return (
    <>
      {props.children}
      {unread + intercomNotificationCount > 0 && (
        <div className="notification-dot" />
      )}
    </>
  );
};

export { UnreadBadge };
